import * as React from "react";
import Box from "@mui/material/Box";
import IconButton from "@mui/material/IconButton";
import Menu from "@mui/material/Menu";
import MenuIcon from "@mui/icons-material/Menu";
import MenuItem from "@mui/material/MenuItem";
import Typography from "@mui/material/Typography";
import AutoStoriesIcon from "@mui/icons-material/AutoStories";
import { NavLink } from "react-router-dom";

function ResponsiveAppBar() {
  const [anchorElUser, setAnchorElUser] = React.useState<null | HTMLElement>(
    null
  );

  const handleOpenUserMenu = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorElUser(event.currentTarget);
  };

  const handleCloseUserMenu = () => {
    setAnchorElUser(null);
  };

  return (
    <Box
      sx={{
        background: "linear-gradient(135deg, #312e81 0%, #4338ca 50%, #6366f1 100%)",
        px: { xs: 2, md: 4 },
        py: 1.5,
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        boxShadow: "0 4px 20px rgba(67,56,202,0.4)",
      }}
    >
      {/* Logo */}
      <Box
        component="a"
        href="/"
        sx={{
          display: "flex",
          alignItems: "center",
          gap: 1,
          textDecoration: "none",
          color: "white",
        }}
      >
        <Box
          sx={{
            width: 36,
            height: 36,
            borderRadius: "10px",
            background: "rgba(255,255,255,0.2)",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            backdropFilter: "blur(4px)",
          }}
        >
          <AutoStoriesIcon sx={{ fontSize: 20, color: "white" }} />
        </Box>
        <Typography
          sx={{
            fontWeight: 800,
            fontSize: "1.3rem",
            letterSpacing: "0.05em",
            color: "white",
            fontFamily: "'Inter', sans-serif",
          }}
        >
          PicDict
        </Typography>
      </Box>

      {/* Menu */}
      <Box>
        <IconButton onClick={handleOpenUserMenu} sx={{ p: 1 }}>
          <MenuIcon sx={{ color: "rgba(255,255,255,0.9)", fontSize: 26 }} />
        </IconButton>
        <Menu
          sx={{
            mt: "45px",
            "& .MuiPaper-root": {
              borderRadius: "12px",
              minWidth: 160,
              boxShadow: "0 8px 32px rgba(0,0,0,0.15)",
              border: "1px solid rgba(99,102,241,0.1)",
            },
          }}
          id="menu-appbar"
          anchorEl={anchorElUser}
          anchorOrigin={{ vertical: "top", horizontal: "right" }}
          keepMounted
          transformOrigin={{ vertical: "top", horizontal: "right" }}
          open={Boolean(anchorElUser)}
          onClose={handleCloseUserMenu}
        >
          <MenuItem
            onClick={handleCloseUserMenu}
            sx={{ py: 1.5, px: 2.5 }}
          >
            <NavLink
              to="/"
              style={{ textDecoration: "none", color: "#1e293b", fontWeight: 500 }}
            >
              Home
            </NavLink>
          </MenuItem>
          <MenuItem
            onClick={handleCloseUserMenu}
            sx={{ py: 1.5, px: 2.5 }}
          >
            <NavLink
              to="/mypage"
              style={{ textDecoration: "none", color: "#1e293b", fontWeight: 500 }}
            >
              MyPage
            </NavLink>
          </MenuItem>
          <MenuItem
            onClick={handleCloseUserMenu}
            sx={{ py: 1.5, px: 2.5 }}
          >
            <NavLink
              to="/quiz"
              style={{ textDecoration: "none", color: "#1e293b", fontWeight: 500 }}
            >
              画像クイズ
            </NavLink>
          </MenuItem>
          <MenuItem
            onClick={handleCloseUserMenu}
            sx={{ py: 1.5, px: 2.5 }}
          >
            <NavLink
              to="/quiz/mistakes"
              style={{ textDecoration: "none", color: "#1e293b", fontWeight: 500 }}
            >
              間違えた問題
            </NavLink>
          </MenuItem>
        </Menu>
      </Box>
    </Box>
  );
}

export default ResponsiveAppBar;
